<template>
        <input
                type="checkbox"
                name="layout"
                :id="inputId"
                :value="inputValue"
                :disabled= "(is_demo_user && !isDisabled) || !isDisabled"
                :checked="checked"
                v-if="size > 0"
        >

</template>

<script>

    import Vue from 'vue';

    export default {
        name: "HkepCheckBox",
        data() {
            return {
                is_demo_user: is_demo_user,
                checked: null
            }
        },
        props: {
            inputId: {
                default: null
            },

            inputValue: {
                default: null
            },
            isDisabled: {
                default: Boolean
            },
            isChecked: {
                type: Boolean
            },
            size: {
                default: 0,
                type: Number
            }
        },
        watch: {
            isChecked(newVal) {
                this.checked = newVal
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HkepCheckBox.vue